import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { UploadPictureModalComponent } from '../components/upload-picture-modal/upload-picture-modal.component';
import { BaseModalSize } from '@shared/ui/modal';
import { UploadImageService } from './upload-image.service';

@Injectable({
  providedIn: 'root',
})
export class UploadImageLayoutModalService {
  constructor(private ngbModal: NgbModal, private uploadImageService: UploadImageService) {}

  openUploadOfficerPictureModal(): Observable<boolean> {
    const modal = this.ngbModal.open(UploadPictureModalComponent, { size: BaseModalSize.Large });
    modal.componentInstance.uploadImageService = this.uploadImageService;

    return from(
      modal.result.then(
        () => true,
        () => false
      )
    );
  }
}
